import React , {Suspense} from 'react';
import {
  Route,
  Switch,
  Redirect,
  HashRouter
} from 'react-router-dom';

import Login from './Views/Login';
import Dashboard from "./Views/Dashboard";
import Inspection from './Views/Inspection';
import FactoryOverview from './Views/factoryOverview';
import LineView from './Views/lineOverview';
import PrinterView from './Views/Printer';
import PreAOI from './Views/PreAOI';
import PostAOI from './Views/PostAOI';
import PickAndPlace from './Views/PickAndPlace';

import DefectDetails from './Views/DefectDetails';
import InspectionDPM from './Views/InspectionDPM';
import TargetVsActual from './Views/TargetVsActual';
import PCBTraceability from './Views/PCBTraceability';

import Layout from './Views/Layout';
import GenericNotFound from './Views/GenericNotFound';
import { useState } from 'react';
import ProtectedRoute from './ProtectedRoutes';
import CheckLogin from './Views/CheckLogin';
import ScreenLoader from './Components/loaders/screen-loader.component'


// eslint-disable-next-line import/no-anonymous-default-export
function App() {
  return (
    <Suspense fallback={<ScreenLoader />}>
      <HashRouter>
        <Switch>
        {/* <Route path="/" component={Login} exact /> */}
        {/* <Redirect path="/login" exact to="/" /> */}
        <Route path="/" component={CheckLogin} exact/>
        <Route path="/login" component={Login} exact />
        <Route>
          <Layout>
            <Switch>
              <ProtectedRoute path="/dashboard" component={ Dashboard } exact={true}/> 
              <ProtectedRoute path="/factoryOverview" component={ FactoryOverview } exact={true}/>
              <ProtectedRoute path="/lineOverview" component={ LineView } exact={true}/> 
              <ProtectedRoute path="/printer" component={ PrinterView } exact={true}/>
              <ProtectedRoute path="/inspection" component={ Inspection } exact={true}/>
              <ProtectedRoute path="/pre-aoi" component={ PreAOI } exact={true}/> 
              <ProtectedRoute path="/PickAndPlace" component={ PickAndPlace } exact={true}/> 
              <ProtectedRoute path="/post-aoi" component={ PostAOI } exact={true}/> 
              <ProtectedRoute path="/target-actual" component={ TargetVsActual } exact={true}/> 
              <ProtectedRoute path="/inspectionDPM" component={ InspectionDPM } exact={true}/> 
              <ProtectedRoute path="/defect-details" component={ DefectDetails } exact={true}/>
              <ProtectedRoute path="/pcb-traceability" component={ PCBTraceability } exact={true}/> 
              <Route path='*' exact={true} component={GenericNotFound} />
              <Route path='/pageNotFound' exact={true} component={GenericNotFound} />
              <Route path='/line:*' exact={true} component={GenericNotFound} />
            </Switch>
          </Layout>
        </Route>
        <Route path='/*' exact={true} component={GenericNotFound} />
      </Switch>
    </HashRouter>
  </Suspense>
  )
}

export default App;